@if (initialized) {
    <div class="grid">

        <div class="col-12">

            @if (singleJobDataReportWidget) {
                <mvs-widget
                        [widgetData]="singleJobDataReportWidget"
                ></mvs-widget>
            }
        </div>
        <div [ngClass]="selectedInstance ? 'col-6' : 'col-12'">
            @if (singleJobOverviewReportWidget) {
                <mvs-widget
                        [widgetData]="singleJobOverviewReportWidget"
                        (onObjectSelect)="handleObjectSelect($event)"
                ></mvs-widget>
            }
        </div>

        @if(selectedInstance){
            <div class="col-6">
                <jb-job-instance-details
                        [jobInstanceId]="selectedInstance"
                ></jb-job-instance-details>
            </div>
        }
    </div>
}